<template>
  <div class="o-fair__detail o-pastfair__detail">
    <h1>{{ fair.displayName }}</h1>
    <div v-for="booth in booths">
      <h2>{{ booth.halleBezeichnung }} / {{ booth.standnummer }}</h2>
      <rubin-document-listing
        v-if="
          booth.regiNr &&
          boothDocuments(booth) !== undefined &&
            boothDocuments(booth).length > 0
        "
        :documents="boothDocuments(booth)"
      />
      <div v-else>
        {{ $t('components.documentListing.list.nodocuments') }}
      </div>
    </div>
  </div>
</template>

<script>
import { getLocalizationInExcludes, localize } from '@/assets/js/helper'
import DocumentListing from '@/components/DocumentListing'
import RubinDocumentListing from '@/components/RubinDocumentListing'

export default {
  name: 'PastFair',
  data() {
    return {}
  },
  computed: {
    fair() {
      let inAndExcludes = getLocalizationInExcludes(this.$i18n.locale)

      return localize(
        this.$store.getters['fair/getFairByCode'](this.$route.params.fair),
        inAndExcludes.include,
        inAndExcludes.exclude
      )

      //        return this.$store.getters['fair/getWithBooths'].find(item => item.idCode == this.$route.params.fair)
    },
    booths() {
      if (this.fair && this.fair.booths !== undefined) {
        return this.fair.booths.filter(booth => booth.status !== 'OP')
      }
      return []
    }
  },
  methods: {
    boothDocuments(booth) {
      this.$store.dispatch('fair/getBoothDocuments', booth.regiNr)
      return this.$store.getters['fair/getBoothDocuments'](booth.regiNr).data
    }
  },
  created() {},
  components: {
    DocumentListing,
    RubinDocumentListing
  }
}
</script>

<style scoped lang="scss">
.o-fair__detail {
  position: relative;

  hr {
    &.double {
      border-bottom: 1px solid black;
    }
  }
}
</style>

<style lang="scss">
.badger-accordion__header {
  margin-top: 4rem;
  margin-bottom: 1rem;

  .js-badger-accordion-header {
    flex-direction: row-reverse;
    border: 1px solid #333;
    border-left: none;
    border-right: none;
    padding: 0.666rem 0;

    &.-ba-is-active {
      border-bottom: none;
    }
  }

  &:nth-of-type(1) {
    margin-top: 1rem;

    .js-badger-accordion-header {
      border-top: none;
    }
  }

  .badger-accordion-toggle {
    flex: auto !important;
    margin-left: 1rem;

    font-size: 21px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.6px;
    color: #4187ba;
  }

  .badger-toggle-indicator {
    margin: 0;
    flex: 0 0 20px !important;

    font-size: 21px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.6px;
    color: #4187ba;
  }
}

.js-badger-accordion-panel {
  padding: 0;
  margin: 0;

  .js-badger-accordion-panel-inner {
    padding: 1rem 0;
  }
}

h2 {
  margin-bottom: 0.5rem !important;
}

.o-pastfair__detail {
  .o-documentlisting {
    margin: 0 0 1rem !important;
  }
}

</style>